export default __webpack_public_path__ + "7de4e1ebf8b5ba504284d1c055d5cc7f.svg";